import {
  createTheme,
  Direction,
  StyledEngineProvider,
  ThemeProvider,
  responsiveFontSizes,
} from "@mui/material/styles";

import themePalette from "./palette";
import componentsOverride from "./overrides";
import { useMemo } from "react";
import { CssBaseline } from "@mui/material";
import Typography from "./typography";
import { TypographyOptions } from "@mui/material/styles/createTypography";
import CustomShadows from "./shadows";
import IBaseLayoutProps from "@/interfaces/Props/IBaseLayoutProps";

const ThemeCustomization = (props: IBaseLayoutProps) => {
  const { children } = props;

  const darkMode = false;

  const theme = themePalette(darkMode ? "dark" : "light");

  const themeCustomShadows = useMemo(() => CustomShadows(theme), [theme]);

  const themeTypography = Typography();

  const themeOptions = useMemo(
    () => ({
      breakpoints: {
        values: {
          xs: 0,
          sm: 768,
          md: 1024,
          lg: 1266,
          xl: 1400,
        },
      },
      direction: "ltr" as Direction,
      mixins: {
        toolbar: {
          minHeight: 60,
          paddingTop: 8,
          paddingBottom: 8,
        },
      },
      palette: theme.palette,
      customShadows: themeCustomShadows,
      typography: themeTypography as TypographyOptions,
    }),
    [theme, themeTypography, themeCustomShadows]
  );

  let themes = createTheme(themeOptions);
  themes.components = componentsOverride(themes);
  themes = responsiveFontSizes(themes);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default ThemeCustomization;
